module.exports = __webpack_public_path__ + "static/media/3_detali_72.92_84.44.01dcddf3.png";